import * as React from 'react';

import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { Collapsible, CollapsibleToggle, ICollapsibleProps } from '@uifabric/portal-ux/lib/Collapsible';
import { ReactNode, useCallback, VFC } from 'react';

interface ILocalizedCollapsibleProps extends Partial<Omit<ICollapsibleProps, 'ariaLabel'>> {
  name?: string;
  header?: ReactNode;
  children?: ReactNode;
}

export const LocalizedCollapsible: VFC<ILocalizedCollapsibleProps> = (props) => {
  const [t] = useLocalization('Account');
  const { name, header, toggle = CollapsibleToggle.header, children, onRenderHeader, onRenderContent, ...rest } = props;
  const renderHeader = useCallback(
    () => (
      <>
        {onRenderHeader?.()}
        {header}
      </>
    ),
    [onRenderHeader, header],
  );
  const renderContent = useCallback(
    () => (
      <>
        {onRenderContent?.()}
        {children}
      </>
    ),
    [onRenderContent, children],
  );

  return (
    <Collapsible
      toggle={toggle}
      ariaLabel={t('collapsibleItem', { param: name })}
      onRenderHeader={renderHeader}
      onRenderContent={renderContent}
      {...rest}
    />
  );
};
